
import { defineComponent, onMounted, ref, computed, inject, nextTick, provide } from 'vue'
import { useRoute } from 'vue-router';

import { errManager, DownloadXLSXPDF } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
//import { useStore } from "vuex";
//import { Actions } from "@/store/enums/StoreEnums";
import GlobalService from '@/core/services/GlobalService';
import { TableInstance } from 'element-plus';

export default defineComponent({
    name: "acrd-clubs",
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        const REPO = ref(process.env.VUE_APP_REPO);
        const { id } = route.params
        const evento = inject<any>("evento")
        const idcheckdoc = inject<any>("idcheckdoc")


        const loader = ref(false)
        const search = ref('')
        const listClubs = ref<any>([]);
        const listStatus = ref<any>([])
        //const idcheckdoc = ref<any>([])
        const indexRow = ref(0);
        const singleTableRef = ref<TableInstance>();
        provide("listStatus", listStatus);

        const getStatus = async () => {
            await GlobalService.get("api/catalogue", btoa("6"))
            .then( (res) => {
                listStatus.value.length = 0
                listStatus.value = res.data
                if(listStatus.value.length>0){
                    setStatus();
                }
            }).catch( ({response}) => {
                errManager(response)
            })
        };

        const setStatus = () => {
            if(idcheckdoc.value.length==0){
                idcheckdoc.value.length = 0
                listStatus.value.forEach((element: any) => {
                    idcheckdoc.value.push(element.id)
                });
            }
        }

        //lista de instituciones por evento
        const getListClubs = async () => {
            //store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
            loader.value = true;
            listClubs.value.length = 0;
            await GlobalService.post('events/institutions', {idevent: id, checkdoc: idcheckdoc.value})
            .then(async(res)=>{
                listClubs.value = res.data
                loader.value = false
                //store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
                await nextTick();

                const row = listClubs.value[indexRow.value];
                if (row) {
                    singleTableRef.value?.setCurrentRow(row);
                }
            }).catch (({response}) => {
                //store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
                loader.value = false
                errManager(response)
            });
        }

        const filteredClubs = computed(()=> {
            return listClubs.value.filter(
                (item) => 
                (item.abrev && item.abrev.toLowerCase().includes(search.value.toLowerCase())) ||
                (item.name && item.name.toLowerCase().includes(search.value.toLowerCase()))
            )
        });

        // Excluir columnas fijas
        const fixedColumns = ["idinstitution", "abrev", "name", "quantity", "avatar", "flags", "idcountry", "country"];
        const dynamicColumns = computed(() => {
            if (listClubs.value.length === 0) return [];
            return Object.keys(listClubs.value[0])
                .filter((key) => !fixedColumns.includes(key))
                .map((key) => ({
                    prop: key,
                    label: key.charAt(0).toUpperCase() + key.slice(1),
                    width: "120",
                    align: "center",
                }));
        });

        const onChangeStatus = (val: number[]) => {
            getListClubs();
        }

        onMounted(async()=>{
            await getStatus();
            getListClubs()
        })

        return {
            t,
            id,
            REPO,
            evento,
            loader,
            search,
            listClubs,
            listStatus,
            idcheckdoc,
            singleTableRef,
            //events
            getListClubs,
            filteredClubs,
            dynamicColumns,
            DownloadXLSXPDF,
            onChangeStatus,
        }
    },
})
